/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SDKEventVirtualPageLoadedV1AllOf
 */
export interface SDKEventVirtualPageLoadedV1AllOf {
    /**
     * Person ID
     * @type {string}
     * @memberof SDKEventVirtualPageLoadedV1AllOf
     */
    person_id?: string;
}

/**
 * Check if a given object implements the SDKEventVirtualPageLoadedV1AllOf interface.
 */
export function instanceOfSDKEventVirtualPageLoadedV1AllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SDKEventVirtualPageLoadedV1AllOfFromJSON(json: any): SDKEventVirtualPageLoadedV1AllOf {
    return SDKEventVirtualPageLoadedV1AllOfFromJSONTyped(json, false);
}

export function SDKEventVirtualPageLoadedV1AllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): SDKEventVirtualPageLoadedV1AllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'person_id': !exists(json, 'person_id') ? undefined : json['person_id'],
    };
}

export function SDKEventVirtualPageLoadedV1AllOfToJSON(value?: SDKEventVirtualPageLoadedV1AllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'person_id': value.person_id,
    };
}

